import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  initialState,
  searchProjectdossiers,
} from '../services/searchProjectdossiers'

import { useProjectdossiersSearchStore } from './useProjectdossiersSearchStore'

export { useProjectdossiersSearch, queryKey }

const queryKey = 'projectdossiers'

const useQueryStore = () => {
  const { query, storeQuery } = useProjectdossiersSearchStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useProjectdossiersSearch = () => {
  const { onChangeFilters, onReset, query, onChangePage, onChangeSort } =
    useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => searchProjectdossiers({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    initialFilters: initialState.query.filters,
    sort: query.sort,
    onChangeFilters,
    onChangeSort,
    onReset,
    onRefresh: refetch,
    onChangePage,
  }
}
